import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router'

import { useAuth } from '@ui/providers/AuthProvider'

export function RequireUserAndOrganization({ children }: { children: JSX.Element }) {
  const auth = useAuth()
  const location = useLocation()

  const { currentMember, currentOrganization, currentInstance } = auth

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    auth.restoreSession(() => {
      setLoading(false)
    })
  }, [auth])

  if (loading) {
    return <div>Loading...</div>
  }

  if (auth && currentMember && !currentOrganization) {
    return <Navigate to="/organizations" replace />
  }

  if (!auth || !currentMember) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state replace />
  }

  // If we have a current instance, we can render the children
  // if we don't have a current instance, but they are visiting the /instances page, we can render the children
  if (!currentInstance && !(location.pathname.match('/manage') || location.pathname.match('/admin'))) {
    return <Navigate to="/setup" replace />
  }

  return children
}
